import ApplicationSerializer from 'cpc-license-manager/serializers/application';

export default class OeeSerializer extends ApplicationSerializer {
  attrs = {
    features: {
      embedded: 'always',
    },
  };
}
